import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { createContext } from 'use-context-selector';
import { api } from 'core/services/api';
import { useAuth } from 'hooks/useAuth';



export const InitializeContext = createContext();

export const InitializeProvider = ({ children }) => {

  const [isLoading, setIsLoading] = useState(true);

  const { initializeAuth } = useAuth();

  const intializeApplication = useCallback(async () => {
    const token = window.localStorage.getItem("@token");
    if(token){
      await api.get("auth/initialize").then(e => {
        if(e.data.success){
          initializeAuth(e.data.content);
        }
      }).catch(e => console.error(e))
    }
    setIsLoading(false);
  },[initializeAuth])

  useEffect(() => intializeApplication(),[intializeApplication])

  return (
    <InitializeContext.Provider
      value={{
        isLoading,
      }}
    >
      {children}
    </InitializeContext.Provider>
  );
};

InitializeProvider.propTypes = {
  children: PropTypes.element.isRequired,
};